import React, { useState } from 'react'

export default function Custom({amount, tip, onSelected, onCancel}) {
  const pointIndex = tip.indexOf('.')
  const [integer, setInteger] = useState(tip.slice(0, pointIndex))
  const [float, setFloat] = useState(tip.slice(pointIndex + 1, tip.length))
  const [mode, setMode] = useState(tip.length ? 'float' : 'int')
  const value = parseFloat((integer || '0') + '.' + (float || '0')).toFixed(2)

  const onKeyPressed = (number) => {
    if (mode == 'int' && integer.length < 6) setInteger(integer + number)
    if (mode == 'float' && float.length < 2) setFloat(float + number)
  }

  const onBackspace = () => {
    if (mode == 'int') return setInteger(integer.slice(0, -1))

    setFloat(float.slice(0,-1))
    if (!float.length) {
      setMode('int')
      setInteger(integer.slice(0,-1))
    }
  }

  const keyboard = () => {
    return <table className='keyboard'>
      <thead>
        <tr>
          <th onClick={() => onKeyPressed('1')}>1</th>
          <th onClick={() => onKeyPressed('2')}>2</th>
          <th onClick={() => onKeyPressed('3')}>3</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td onClick={() => onKeyPressed('4')}>4</td>
          <td onClick={() => onKeyPressed('5')}>5</td>
          <td onClick={() => onKeyPressed('6')}>6</td>
        </tr>
        <tr>
          <td onClick={() => onKeyPressed('7')}>7</td>
          <td onClick={() => onKeyPressed('8')}>8</td>
          <td onClick={() => onKeyPressed('9')}>9</td>
        </tr>
        <tr>
          <td onClick={() => onKeyPressed('0')}>0</td>
          <td onClick={() => setMode('float')}>.</td>
          <td onClick={onBackspace}>&#x232B;</td>
        </tr>
      </tbody>
    </table>
  }

  return <div className='tip-content'>
    <div className='tip-header'>
      <div className='amount'>{`$${parseFloat(amount).toFixed(2)}`}</div>
      <div className='add-label'>Add a tip</div>
    </div>

    <div className='tip-body'>
      <span className='custom-amount'>{`$${value}`}</span>
      {keyboard()}
      <div className='tip-button custom-option' onClick={() => onSelected('')}>No Tip</div>
      <div className='tip-button custom-option add-tip' onClick={() => onSelected(value)}>Add Tip</div>
      <div className='tip-button custom-option cancel' onClick={onCancel}>Cancel</div>
    </div>
  </div>
}
